import { Children, isValidElement, useMemo } from 'react';

const useMasonry = (children, columns) => {
    const columnsChildren = useMemo(() => {
        const group = Array.from({ length: columns }, () => []);

        Children.forEach(children, (child, index) => {
            if (isValidElement(child)) {
                group[index % columns].push(child);
            }
        });

        return group;
    }, [children, columns]);

    return columnsChildren;
};

export default useMasonry;
